import React from 'react'
import useTranslation from '../shared/TranslationProvider'

function CharCounter({ value, maxLength, id }) {
  const remainingChars = value ? maxLength - value.length : maxLength
  const { t } = useTranslation()

  return (
    <p id={id} className="self-end text-sm">
      {t('char_remaining', { count: remainingChars })}
    </p>
  )
}

export default CharCounter
